<template>
  <div :class="$style.container">
    <div :class="$pgCTStyle.headerContainer">
      <!-- <div v-if="!props.isGroupComponent" :class="$style.titleEmptyContainer"></div> -->
      <div :class="$pgCTStyle.title">{{ title }}</div>
      <div :class="$pgCTStyle.headerRightCTAs">
        <PGHeaderActionButton
          v-if="showAllGroupsCTA"
          :text="$t('all-groups')"
          :clickFunction="props.openAllGroupsCastVotes"
          backBg="#000000"
          frontBg="#676767"
          textColor="#ffc642"
          :button-width="isMobile ? '70px' : isTablet ? '72px' : '86px'"
        />
      </div>
    </div>
    <div :class="$style.voteWaitContainer">
      <div :class="$style.votesCount">
        {{ props.votesCasted }} <span :class="$style.votesAvailable">/ {{ props.playersCount }}</span>
      </div>
      <div :class="$style.votesCastedText">  {{ props.isPrelim ? $t('prelim-votes-casted') : $t('votes-casted') }}</div>
      <template v-if="props.playersCount && props.playersCount > 0">
        <template v-if="props.votesCasted != props.playersCount">
          <div :class="$style.waitText">{{ props.isPrelim ? $t('prelim-wait') : $t('saboteur-vote-wait') }}</div>
          <!-- <img :class="$style.waitIcon" :src="hostWaitIcon" alt="Success" /> -->
          <img :class="$style.waitLoader" :src="voteCountWaitLoaderGif" alt="message-send-loader" />
        </template>
        <template v-else>
          <div :class="$style.votedTextContainer">
            <img :class="$style.successIcon" :src="successIcon" alt="all-voted-icon" />
            <div :class="$style.successText">{{ $t('group-all-voted') }}</div>
          </div>
          <!-- <img :class="$style.waitIcon" :src="hostWaitIcon" alt="Success" /> -->
          <div :class="$style.emptyLoader"></div>
        </template>
      </template>
    </div>
  </div>
</template>

<script setup>
import styles from "@/css/CastVoteBoxForHost.module.css";
// import globalStyles from "@/css/global.module.css";
import playGameComponentsTemplateStyles from "@/css/PlayGameComponentsTemplate.module.css";
import VoteCountWaitLoaderGif from "@/assets/gifs/vote-count-wait-loader.svg";
import SuccessIcon from "@/assets/icons/verified-account.svg";
// import UtilButton from "../util/UtilButton.vue";
import { computed } from "vue";
import { NOOP } from "@/utils/functions";
import PGHeaderActionButton from "../buttons/PGHeaderActionButton.vue";
import useDeviceType from "@/utils/useDeviceType";

const device = useDeviceType();

// const width = device.width.value;
// const height = device.height.value;
const isMobile = device.isMobile.value;
const isTablet = device.isTablet.value;
// const isDesktop = device.isDesktop.value;

const $style = styles;
// const $globalStyle = globalStyles;
const $pgCTStyle = playGameComponentsTemplateStyles;
const voteCountWaitLoaderGif = VoteCountWaitLoaderGif;
const successIcon = SuccessIcon;

// eslint-disable-next-line
const props = defineProps({
  canOpenAllGroups: {
    type: Boolean,
    required: false,
    default: false,
  },
  playersCount: {
    type: Number,
    required: false,
    default: 0,
  },
  votesCasted: {
    type: Number,
    required: false,
    default: 0,
  },
  openAllGroupsCastVotes: {
    type: Function,
    required: false,
    default: NOOP,
  },
  title: {
    type: String,
    required: true,
    default: "",
  },
  // isGroupComponent: {
  //   type: Boolean,
  //   required: false,
  //   default: false,
  // },
  isPrelim: {
    type: Boolean,
    required: false,
    default: false,
  },
});

const showAllGroupsCTA = computed(() => {
  return props.openAllGroupsCastVotes !== NOOP && props.canOpenAllGroups;
});
</script>

<style scoped></style>
